import React, { useEffect } from 'react';
import { ProtocolList, ProtocolFilters, HeadingWithButton, LoadingWithText, } from 'components';
import { useProtocolFilters } from 'hooks';
import classnames from 'classnames/bind';
import styles from './ProtocolListWithHeader.scss';
const cx = classnames.bind(styles);
const ProtocolListWithHeader = ({ types = [], protocolsToDisplay, loading, sendingProtocol, onDeleteClick, onMount, headingTitle = '', }) => {
    const { filteredProtocols, setDateRange, setSearchText, setSelectedType, setSelectedSortMethod, dateRange, searchText, selectedType, selectedSortMethod, } = useProtocolFilters(protocolsToDisplay);
    const changeSelectedType = (newSelectedType) => {
        setSelectedType(newSelectedType?.value ?? 'All types');
    };
    const changeSearchText = (event) => {
        setSearchText(event?.target?.value);
    };
    useEffect(() => {
        onMount();
    }, []);
    return (React.createElement("section", { className: cx('container') },
        sendingProtocol && (React.createElement(LoadingWithText, { message: "Sending protocol to device..." })),
        loading && React.createElement(LoadingWithText, { message: "Loading protocols..." }),
        React.createElement(HeadingWithButton, { title: headingTitle }),
        React.createElement(ProtocolFilters, { searchText: searchText, selectedType: selectedType, types: types, onSearchTextChange: changeSearchText, onTypeChange: changeSelectedType, dateRange: dateRange, onDateRangeChange: setDateRange, selectedSortMethod: selectedSortMethod, onSortMethodChange: setSelectedSortMethod }),
        React.createElement(ProtocolList, { protocols: filteredProtocols, onDeleteClick: onDeleteClick })));
};
export default ProtocolListWithHeader;
